<template>
  <div class="main">
    <div class="main-title-box">
      <div class="title">规则设置</div>
      <div class="add-rule" @click="addRule()">
        <i class="el-icon-plus"></i>
        <div class="text">新增规则</div>
      </div>
    </div>
    <div class="picker">
      <van-picker :columns="columns" @change="change" :default-index="defaultIndex"/>
    </div>
    <div class="form-sub-box">
      <div class="submit-btn" @click="onSubmit">
        保存
      </div>
    </div>
  </div>
</template>
<script>
import {getRuleList, setPileRule} from "@/api/newApi";
import {Toast} from "vant";

export default {
  name: "select",
  data() {
    return {
      userId: localStorage.getItem("userId"),
      columns: [],
      rules: [],
      defaultIndex: 0,
      formData: {
        Id: "",
        wxRuleId: "",
      }
    }
  },
  created() {
    this.getList()
    this.formData.Id = this.$route.query.id;
    this.formData.wxRuleId = this.$route.query.wxRuleId;
  },
  methods: {
    onSubmit() {
      setPileRule(this.formData).then((res) => {
        if (res.message.code == 0) {
          Toast("设置规则成功");
          this.$router.back(-1)
        }
      });
    },
    change(picker, value, index) {
      this.formData.wxRuleId = this.rules[index].id

    },
    getList() {
      getRuleList({deviceType: 4, pageNo: 1, pageSize: 999}).then((res) => {
        this.rules = res.data.records;
        this.defaultIndex = this.rules.findIndex((item => item.id == this.formData.wxRuleId))
        this.columns = this.rules.map((item) => {
          return item.changeName
        })
      });
    },
    addRule() {
      this.$router.push({
        path: `/admin/editrule/`,
        query: {
          userId: this.userId,
        },
      });
    },
  },
}
</script>
<style scoped lang="scss">
@import "@/assets/sass/state.scss";

.main {
  padding: $divPadding;
  height: 100%;
  background-color: #F5F5F6;


  .picker {
    margin-top: $divPadding;
  }

  .form-sub-box {
    margin-top: 1.5rem;

    .submit-btn {
      background-color: #1D3FC9 !important;
    }

  }


  ::v-deep .van-picker__mask {
    display: block !important;
  }

  ::v-deep .van-picker-column__item {
    .van-ellipsis {
      font-size: 0.4324rem;
      color: #1D2129;
    }
  }

  ::v-deep .van-picker__columns {
    background-color: white;
    border-radius: $borderRadius;
  }

  ::v-deep .van-picker__toolbar {
    display: none;
  }

  .main-title-box {
    display: flex;
    justify-content: space-between;
    padding-top: 0.1rem;

    .title {
      font-size: 0.3783rem;
      align-self: center;
    }

    .add-rule {
      align-self: center;
      display: flex;
      border: 1px solid #7AA0FA;
      border-radius: 2rem;
      padding: 0.1rem 0.2rem;

      .el-icon-plus,
      .text {
        font-size: 0.3243rem;
        align-self: center;
        color: #7AA0FA;
      }
    }
  }
}
</style>